import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PermissionDirective } from '../../../shared/components/directives/permissions.directives';

@Component({
  selector: 'app-card',
  standalone: true,
  imports: [CommonModule,RouterModule, PermissionDirective],
  templateUrl: './card.component.html',
})
export class CardComponent {
  @Input() title!: string;
  @Input() count!: number;
  @Input() subTitle?: string;
  @Input() subCount?: number;
  @Input() link!: string;
  @Input() addLink!: string;
  @Input() colorClass!: string;
  @Input() textColorClass!: string;
  @Input() addPermission!: string;
  @Input() viewPermission!: string;
}
